import { Div, Link, Select, SelectOption, Span } from '@tblabs/truffle';
import { AppConfigProvider } from '../Services/AppConfigProvider';


export class ServerSelector extends Div
{
    private pinger = new Link("🚀").NoDecorationOnHover()
        .OnClick(() => this.Ping())
    constructor(private _config: AppConfigProvider)
    {
        super();
        this.DisplayInlineBlock();

        this.Append(
            new Select(_config.ServerId, _config.ServersPool.map(x => new SelectOption(x.Name, x.Id))).Width(132)
                .OnChange(() => this.Ping()),
            this.pinger.MarginLeft(8),
        );

        this.Ping();
    }

    private async Ping(): Promise<void>
    {
        try
        {
            this.pinger.Text("🚀");
            const res = await fetch(this._config.ServerInfo.Addr + "/ping");
            const con = await res.text();
            this.pinger.Text(con == "pong" ? "✅" : "💔");
        }
        catch (ex)
        {
            this.pinger.Text("💔");
        }
    }
}
